var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmbedWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8,8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12V12Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4563 7.62071C17.5073 7.47083 17.5153 7.30967 17.4794 7.15548C17.4435 7.00129 17.3651 6.86024 17.2532 6.7483C17.1412 6.63635 17.0002 6.55799 16.846 6.52209C16.6918 6.48619 16.5306 6.49417 16.3808 6.54515L9.00439 9.00915L14.9962 15.001L17.4563 7.62071Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00402 8.99609L6.54295 16.3764C6.49198 16.5262 6.48399 16.6874 6.51989 16.8416C6.55579 16.9958 6.63415 17.1368 6.7461 17.2488C6.85804 17.3607 6.9991 17.4391 7.15328 17.475C7.30747 17.5109 7.46863 17.5029 7.61851 17.4519L14.9988 14.9918",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbedWebsite);
export default __webpack_public_path__ + "static/media/EmbedWebsite.7abcaf605bedb46d9efa6448e4d50325.svg";
export { ForwardRef as ReactComponent };